import { Injectable } from "@angular/core";
import { ConfigJsonModelService } from "../models/config-json-model.service";
import { LanguageJsonModelService } from "../models/language-json-model.service";
import { ConfigDocModelService } from "../models/config-doc-model.service";
import { CourseStructureModelService } from "../models/course-structure-model.service";
import { CourseMenuModelService } from "../models/course-menu-model.service";
import { AppHeaderModelService } from "../views/app-header/app-header-model.service";
import { AppSidebarModelService } from "../views/app-sidebar/app-sidebar-model.service";
import { CourseContextModelService } from "../models/course-context-model.service";
import { DescriptorModelService } from "../models/descriptor-model.service";
import { UtilityScripts } from "../../helpers/utility-scripts";
import { DefinitionModelService } from "../models/definition-model.service";
import { TrackingManager } from "../tracking/tracking-manager";
import { Config } from "app/core/vo/config";
import { CourseTimerService } from "../../services/course-timer.service";
import { AppConstants } from "app/core/vo/app-constants";
import { HttpService } from "../../services/http.service";
import { GeoLocationModelService } from "../views/geolocation/geolocation.model.service";
import { StateSpecificContentModelService } from "../models/state-specific-content-model.service";
import { LoaderService } from "../../directives/loader-animation/loader.service";
import { AppServices } from "app/app.services";
import { OrientationModelService } from "../models/orientation-model.service";
import { OrientationService } from "../../services/orientation.service";
import { ApplicationModel } from "../models/application.model";
import * as introJs from "../../../assets/introjs/intro.js";
import { SettingModelService } from "../models/setting-model.service";
import { ApplicationUtilityService } from "app/services/application-utility.service";
import { Subscription } from "rxjs";
import { CMI5 } from "../tracking/cmi5";
import { AppHeaderModelServiceAdaptive } from "../views/adaptive/app-header/app-header-model.service";
import { ThemingService } from "../../services/theming.service";
import { AdaptiveCourseModelService } from "../models/adaptive-course-model.service";
import { LaunchDarklyService } from "app/launch-darkly/launch-darkly.service";
import { RubricStatusVO } from "app/rubrics/adaptive/vo/rubricStatusvo";
@Injectable()
export class CourseControllerService {
	introJS = introJs();
	private modelInitSubscription: any;
	private trackingInitSubscription: any;
	private descriptorModelSubscription: any;
	private orientationModelSubscription: any;
	private geolocationSubscription: any;
	private trackingManagerSubscription: any;
	private settingInitSubscription: any;
	private maxIdleTimeReachedSubscription: any;
	public strConfigDocPath: string;
	private objParams: any;
	private bUpdateGeoLocation: boolean;
	public isCourseLoaded: boolean;
	private showOrientation: Boolean;
	public bShowPopup: boolean = true;
	public bGeoLocationPresent: boolean = true;
	public showIntroJS: boolean;
	private isXAPI = false;
	private isCMI5 = false;

	private _skippableOrientation: Boolean = false;
	private _enabledNext: Boolean = false;
	private _enabledNextTimeoutID: any;
	private _maxStepIndexReached: number = 0;

	public _ieOrientationDisplyed: boolean = true;
	private saveIntTimer: any;
	private exitCourseSubscription: Subscription;

	public isAdaptive = false;
	public rubricViewStatus:any;
    public rubricViewStatusStr:string = '';    
	public rubricStatusVO = new RubricStatusVO;

	constructor(
		public configJsonModel: ConfigJsonModelService,
		private langJsonModel: LanguageJsonModelService,
		private configDocModel: ConfigDocModelService,
		private courseStructureModel: CourseStructureModelService,
		private courseMenuModel: CourseMenuModelService,
		private courseContextModel: CourseContextModelService,
		private descriptorModel: DescriptorModelService,
		private definitionModel: DefinitionModelService,
		private appHeaderModel: AppHeaderModelService,
		private appHeaderModelAdaptive: AppHeaderModelServiceAdaptive,
		private appSidebarModel: AppSidebarModelService,
		private courseTimer: CourseTimerService,
		private httpService: HttpService,
		private geoLocationModel: GeoLocationModelService,
		private stateSpecificContentModel: StateSpecificContentModelService,
		private appService: AppServices,
		private loaderService: LoaderService,
		private orientationModel: OrientationModelService,
		public orientation: OrientationService,
		private settingModel: SettingModelService,
		private appUtilityService: ApplicationUtilityService,
		private themingService: ThemingService,
		private adaptiveCourseModelService: AdaptiveCourseModelService,
		private launchDarklyService: LaunchDarklyService
	) {
		/* this.setUpConfigPath();
      		this.initConfigJsonModel();*/
		//   if( /MSIE \d|Trident.*rv:/i.test(navigator.userAgent))
		//     this.checkCourseLoaded();
	}

	public initCourseControllerService() {
		this.objParams = UtilityScripts.getConfigDetailsFromLocation(
			document.location.search.substr(1).split("&")
		);
		//this.isCMI5 = (this.objParams.endpoint)?true:false;
		if (this.objParams.content_token) this.isXAPI = true;
		else if (this.objParams.endpoint) this.isCMI5 = true;

		if (this.isCMI5 || this.isXAPI) {
			this.initConfigJsonModelForCMI5();
		} else {
			this.setUpConfigPath();
			this.loadSettingsXML();
		}
	}

	public updateRubricViewedStatus(rubricName) {
		if(this.rubricStatusVO[rubricName])
			this.rubricStatusVO[rubricName] = "v";
		this.rubricViewedStatusConvertToString();
    }


    private rubricViewedStatusConvertToString() {
        this.rubricViewStatus = Object.keys(this.rubricStatusVO).map(key => this.rubricStatusVO[key].toString())
        this.rubricViewStatusStr =  this.rubricViewStatus.join("");
		TrackingManager.instance.saveRubricViewed(this.rubricViewStatusStr);
    }

    public updateRubricViewedStatusFromLMS() {
        let rubricViewStatusData = this.rubricViewStatusStr
        let viewedStatusArr = rubricViewStatusData.split('')
        let keys = Object.keys(this.rubricStatusVO)
        keys.forEach((key, i) => this.rubricStatusVO[key] = viewedStatusArr[i]);
    }

    public get rubricViewedStatus() {
        if(this.rubricViewStatusStr) { 
            this.updateRubricViewedStatusFromLMS()
        }
        return this.rubricStatusVO;
    }

	private initConfigJsonModelForCMI5(configPath = "assets/config.json") {
		const strConfigJsonPath: string = configPath; //(this.objParams !=undefined && this.objParams.customConfig && this.objParams.customConfig!='')?this.objParams.customConfig:"assets/config.json";
		this.modelInitSubscription = this.configJsonModel.notifier.subscribe(
			(data) => {
				if (data) {
					this.handleConfigJsonModelInitForCML5(data);
				}
			}
		);
		this.configJsonModel.initialize(strConfigJsonPath);
	}

	private handleConfigJsonModelInitForCML5(data) {
		let _config = new Config();
		let cbtData = Object.assign({}, _config.toObject(data), this.objParams);
		_config.setData(cbtData);
		_config.configData["trackMode"] = "cmi5";
		ApplicationModel.instance.mode = _config.configData["opProfile"];
		if (!this.strConfigDocPath) {
			this.strConfigDocPath = cbtData["configDoc"];
		}
		//this.addTrackJS(_config);
		//this.setUpConfigPath();
		this.appService.configJSONLoadComplete(_config.configData);
		this.setUpConfigPathForCMI5(_config);
	}

	private setUpConfigPathForCMI5(_config) {
		this.loaderService.show();
		this.bUpdateGeoLocation = false;
		this.isCourseLoaded = false;
		this.showOrientation = false;
		// read url for configuration location vs using a configuration file
		//this.objParams = UtilityScripts.getConfigDetailsFromLocation(document.location.search.substr(1).split('&'));
		//this.strConfigDocPath = "../coi_custom/_demo_employee/_demo_employee_config.xml";//this.objParams.configDoc;
		this.initTimer();

		TrackingManager.instance.initialize(
			_config.configData,
			this.httpService,
			this.courseTimer,
			this.courseContextModel,
			this.appService,
			this.adaptiveCourseModelService,
			this.courseMenuModel
		);
		this.trackingManagerSubscription =
			this.appService.trackingManagerInitilaizedEvent$.subscribe((data) => {
				this.trackingInitSubscription =
					TrackingManager.instance.notifier.subscribe((data) => {
						if (data) {
							this.trackingInitComplete(data);
						}
					});
				if (this.isCMI5) {
					let CMI5obj = TrackingManager.instance.trackingObj as CMI5;
					this.strConfigDocPath = CMI5obj.getLaunchURLVO().configDoc;
					this._skippableOrientation =
						this.orientation.skippableOrientation =
						this.orientation.enabledNext =
							TrackingManager.instance.config.opProfile ==
							AppConstants.DEMO_MODE
								? true
								: false;
				} else {
					this.strConfigDocPath = _config.configData["configDoc"];
				}
			});
	}

	public setUpConfigPath() {
		this.loaderService.show();
		this.bUpdateGeoLocation = false;
		this.isCourseLoaded = false;
		this.showOrientation = false;
		// read url for configuration location vs using a configuration file
		this.objParams = UtilityScripts.getConfigDetailsFromLocation(
			document.location.search.substr(1).split("&")
		);
		this.strConfigDocPath = this.objParams.configDoc;
		//console.log("this.strConfigDocPath ",this.objParams);
		//this.loadSettingsXML();
	}

	public loadSettingsXML() {
		if (this.objParams.setting) {
			this.settingInitSubscription = this.settingModel.notifier.subscribe(
				(data) => {
					if (data.response == "success") {
						this.handleSettingModelInit(data.data);
					} else if (data.response != undefined) {
						this.initConfigJsonModel(this.objParams.setting + "/config.json");
					}
				}
			);
			this.settingModel.initialize(this.objParams.setting);
		} else {
			this.initConfigJsonModel();
		}
	}

	public handleSettingModelInit(data) {
		this.initConfigJsonModel(
			data.getElementsByTagName("config_json")[0].textContent
		);
	}

	public initConfigJsonModel(configPath = "assets/config.json") {
		const strConfigJsonPath: string = configPath; //(this.objParams !=undefined && this.objParams.customConfig && this.objParams.customConfig!='')?this.objParams.customConfig:"assets/config.json";
		//const strConfigJsonPath:string = (this.objParams !=undefined && this.objParams.setting && this.objParams.setting!='')?this.objParams.setting+"/config.json":"assets/config.json";
		//this.modelInitSubscription = this.configJsonModel.subscribe(this.handleConfigJsonModelInit.bind(this));
		this.modelInitSubscription = this.configJsonModel.notifier.subscribe(
			(data) => {
				if (data) {
					this.handleConfigJsonModelInit(data);
				}
			}
		);
		this.configJsonModel.initialize(strConfigJsonPath);
		//console.log("Aliasgar Script path ",this.settingModel.settingXMLData.getElementsByTagName("script_js")[0].textContent);
	}

	private handleConfigJsonModelInit(data) {
		let _config = new Config();
		let cbtData = Object.assign({}, _config.toObject(data), this.objParams);
		_config.setData(cbtData);
		_config.configData["trackMode"] =
			this.objParams.trackMode || _config.configData["trackMode"];
		ApplicationModel.instance.mode = _config.configData["opProfile"];
		if (!this.strConfigDocPath) {
			this.strConfigDocPath = cbtData["configDoc"];
		}
		this.modelInitSubscription.unsubscribe();
		this._skippableOrientation =
			this.orientation.skippableOrientation =
			this.orientation.enabledNext =
				this.objParams.opProfile == AppConstants.DEMO_MODE ||
				ApplicationModel.instance.mode == AppConstants.DEMO_MODE
					? true
					: false;
		this.appService.configJSONLoadComplete(_config.configData);

		this.addTrackJS(_config);
	}

	private async addTrackJS(_config) {
		let jsPath;
		if (this.settingModel.settingXMLData) {
			jsPath =
				this.settingModel.settingXMLData.getElementsByTagName("script_js")[0]
					.textContent;
		} else {
			jsPath = "assets/js/track.js";
		}
		//await  UtilityScripts.addScriptTag(jsPath);
		await UtilityScripts.addScriptTag(jsPath);
		this.addConfigScriptTags(_config);
	}

	protected async addConfigScriptTags(_config) {
		const trackMode = _config.configData["trackMode"];
		console.log("trackMode  ", trackMode);
		if (trackMode.toLowerCase() === "scorm2004") {
			await UtilityScripts.addScriptTag("assets/js/scorm2004_track.js");
			this.handleScriptTagsAdded(_config);
		} else {
			this.handleScriptTagsAdded(_config);
		}
	}
	protected handleScriptTagsAdded(_config) {
		console.log("handleScriptTagsAdded ");
		(window as any).init_cbt_data(_config.configData);
		console.log(" _config.configData ", _config.configData);
		this.initTimer();
		this.modelInitSubscription.unsubscribe();
		this.trackingInitSubscription = TrackingManager.instance.notifier.subscribe(
			(data) => {
				if (data) {
					this.trackingInitComplete(data);
				}
			}
		);
		TrackingManager.instance.initialize(
			_config.configData,
			this.httpService,
			this.courseTimer,
			this.courseContextModel,
			null,
			this.adaptiveCourseModelService,
			this.courseMenuModel
		);
	}

	private trackingInitComplete(data) {
		if (!this.isCMI5 && !this.isXAPI)
			this.trackingInitSubscription.unsubscribe();

		console.log(data);
		if (data) {
			this.initLanguageJsonModel();
		}
		if (data.initialLessonLocation) {
			this.bShowPopup = false;
		}
		if (data.geoLocation === undefined) {
			this.bGeoLocationPresent = false;
		}
		this.launchDarklyService.initialize(TrackingManager.instance.trackingVO.clientKey);
	}
	private initLanguageJsonModel() {
		const strLanguageJsonPath: string = "assets/languages.json";
		this.modelInitSubscription = this.langJsonModel.notifier.subscribe(
			(data) => {
				if (data) {
					this.handleLangJsonModelInit(data);
				}
			}
		);
		this.langJsonModel.initialize(strLanguageJsonPath);
		console.log("initLanguageJsonModel");
	}
	private handleLangJsonModelInit(data) {
		console.log("handleLangJsonModelInit");
		this.modelInitSubscription.unsubscribe();
		this.initConfigDocModel();
	}
	private initConfigDocModel() {
		console.log("init config model.....", this.strConfigDocPath);
		this.modelInitSubscription = this.configDocModel.notifier.subscribe(
			(data) => {
				if (data) {
					let isArchivedTag = (this.configDocModel.configXML.getElementsByTagName("isArchived")[0])?this.configDocModel.configXML.getElementsByTagName("isArchived")[0].textContent:"false";
					if(isArchivedTag.toLowerCase() === "true"){
						document.write('<span style="color: red;font-weight:bold;text-align:center;width: 100%;font-size: larger;padding-top: 20%;position: absolute;">This course is no longer available as it has been archived.</span>');
					} else {
						this.handleConfigDocModelInit();
					}
				}
			}
		);
		this.configDocModel.initialize(this.strConfigDocPath);
	}
	private handleConfigDocModelInit() {
		console.log("handle config doc model init...");
		this.modelInitSubscription.unsubscribe();
		this.configTheming();
		this.initCourseStructureModel();
		this.isAdaptive = this.configDocModel.isAdaptive;
		if (this.isAdaptive) this.initAdaptiveCourseModel();

		ApplicationModel.instance.adaptiveLearningFlow =
			this.configDocModel.adaptiveLearningFlow;
		ApplicationModel.instance.isAdaptivePlayer = this.isAdaptive;
		ApplicationModel.instance.skipTo = this.configDocModel.skipTo;
		//this.initGeoLocation();
	}

	private initAdaptiveCourseModel() {
		this.modelInitSubscription =
			this.adaptiveCourseModelService.notifier.subscribe((data) => {
				if (data) {
					this.handleAdaptiveCourseModelInit(data);
				}
			});
		this.adaptiveCourseModelService.initialize(
			this.configDocModel.adaptiveXMLPath
		);
	}
	private handleAdaptiveCourseModelInit(data) {}

	private initCourseStructureModel() {
		console.log("initCourseStructureModel()");
		this.modelInitSubscription = this.courseStructureModel.notifier.subscribe(
			(data) => {
				if (data) {
					this.handleStructureModelInit();
				}
			}
		);
		if (TrackingManager.instance.lessonLocation[0])
			this.courseContextModel.currentLanguage =
				TrackingManager.instance.lessonLocation[0];
		else
			this.courseContextModel.currentLanguage =
				this.configDocModel.availableLanguages[0].language;

		this.courseStructureModel.initialize({
			xmlPath: this.configDocModel.structureDocPath,
			sceneSelection: this.configDocModel.sceneSelection,
			language: this.courseContextModel.currentLanguage,
		});
	}
	private handleStructureModelInit() {
		this.modelInitSubscription.unsubscribe();
		this.initBookmark();
		this.initCourseMenuModel();
		this.initCourseContextModel();
		this.setTimer();
		/*this.initDescriptor();
          this.initDefinition();*/
	}
	private initCourseMenuModel() {
		//this.modelInitSubscription = this.courseMenuModel.subscribe(this.handleCourseMenuModelInit.bind(this));
		this.modelInitSubscription = this.courseMenuModel.notifier.subscribe(
			(data) => {
				if (data) {
					this.handleCourseMenuModelInit();
				}
			}
		);
		this.courseMenuModel.initialize(this.configDocModel.menuXMLPath.trim());
	}

	private handleCourseMenuModelInit() {
		this.modelInitSubscription.unsubscribe();
		// this.initDescriptor();
		this.setLabelInLanguageOptions();
		//this.initDefinition();
		//this.setTimer();
	}
	private initCourseContextModel() {
		if (
			TrackingManager.instance.lessonLocation &&
			TrackingManager.instance.lessonLocation.length > 2 &&
			TrackingManager.instance.trackingVO.lessonStatus != AppConstants.COMPLETE
		) {
			setTimeout(() => {
				this.courseContextModel.setMaxVisitedPage();
				this.courseContextModel.updatePageById(
					TrackingManager.instance.lessonLocation[4]
				);
				this.initDescriptor();
				this.initDefinition();
			}, 2000);
		} else {
			this.initCourseContext();
			this.initDescriptor();
			this.initDefinition();
		}
	}
	private initCourseContext() {
		//console.log("initCourseContext");
		if (
			this.objParams.moduleid &&
			this.objParams.sceneid &&
			this.objParams.pageid
		) {
			this.courseContextModel.initialize({
				pageNum: parseInt(this.objParams.pageid),
				sceneNum: parseInt(this.objParams.sceneid),
				moduleNum: parseInt(this.objParams.moduleid),
			});
		} else {
			this.courseContextModel.initialize({
				pageNum: 0,
				sceneNum: 0,
				moduleNum: 0,
			});
		}
	}
	private initDescriptor() {
		//this.modelInitSubscription = this.descriptorModel.subscribe(this.handleDescriptorModelInit.bind(this));
		this.descriptorModelSubscription = this.descriptorModel.notifier.subscribe(
			(data) => {
				if (data) {
					this.handleDescriptorModelInit();
				}
			}
		);
		this.descriptorModel.initialize(
			this.configDocModel.getDescriptorXMLPath(
				this.courseContextModel.currentLanguage
			)
		);
	}
	private handleDescriptorModelInit() {
		this.descriptorModelSubscription.unsubscribe();
		this.setAppHeaderData();
		this.setSideBarData();
		this.setRightContainer();
		this.setPresentationModeData();
		//if(!(/MSIE \d|Trident.*rv:/i.test(navigator.userAgent)))
		this.checkCourseLoaded();
		this.initGeoLocation();
		this.startSaveIntTimer();
		this.courseContextModel.updateCoursePage();
	}
	private initGeoLocation() {
		if (this.configDocModel.availableGeoLocations) {
			const path: string = this.configDocModel.getLocationMenuXML(
				this.courseContextModel.currentLanguage
			);
			if (TrackingManager.instance.trackingVO["geoLocation"])
				this.modelInitSubscription = this.geoLocationModel.notifier.subscribe(
					(data) => {
						if (data) {
							this.handleGeoLocationInit(data);
						}
					}
				);
			this.geoLocationModel.initialize(
				path,
				this.configDocModel.availableGeoLocations
			);
		}
		//this.initCourseStructureModel();
		//else{
		//  this.initCourseStructureModel();
		//}
	}
	private handleGeoLocationInit(data) {
		console.log("Data ", data);
		if (data == "locationSet") {
			this.modelInitSubscription.unsubscribe();
			this.initStateSpecificContentModelIfLessonStatus();
		}
	}
	private initDefinition() {
		this.definitionModel.initialize(
			this.configDocModel.getDefinitionXMLPath(
				this.courseContextModel.currentLanguage
			)
		);
	}
	private initBookmark() {
		console.log("init bookmark calledinit bookmark called")
		//console.log("this.courseStructureModel.courseStructure ",this.courseStructureModel.courseStructure)
		TrackingManager.instance.initBookmarks(
			this.courseTimer.sessionTimeString,
			this.courseTimer.totalTimeString,
			this.courseStructureModel.courseStructure
		);
		this.rubricViewStatusStr = TrackingManager.instance.parseRubricViewedStatus()
		this.initLanguage();
		this.initPresentationMode();
		this.initOrientationModel();
		setTimeout(() => {
			this.courseContextModel.updateCompletedPagesInCourse();
		}, 200);
	}
	private initLanguage() {
		if (
			TrackingManager.instance.lessonLocation &&
			TrackingManager.instance.lessonLocation.length >= 2
		) {
			this.courseContextModel.currentLanguage =
				TrackingManager.instance.lessonLocation[0];
			this.courseStructureModel.updateLanguage(
				TrackingManager.instance.lessonLocation[0]
			);
		} else {
			this.courseContextModel.currentLanguage =
				this.configDocModel.availableLanguages[0].language;
			this.courseStructureModel.updateLanguage(
				this.configDocModel.availableLanguages[0].language
			);
		}
	}
	private initPresentationMode() {
		if (
			TrackingManager.instance.lessonLocation &&
			TrackingManager.instance.lessonLocation.length >= 2
		) {
			this.configDocModel.setPresentationMode(
				TrackingManager.instance.lessonLocation[1],true
			);
			ApplicationModel.instance.presMode =
				TrackingManager.instance.lessonLocation[1];
		}
	}
	private initOrientationModel() {
		/* console.log(
			"this.configDocModel.orientationXML     :",
			this.configDocModel.orientationXML(
				this.courseContextModel.currentLanguage
			)
		);
		console.log(
			"this.configDocModel.orientationXML  hasOrientation    :",
			this.configDocModel.hasOrientation(
				this.courseContextModel.currentLanguage
			)
		); */
		if (
			this.configDocModel.hasOrientation(
				this.courseContextModel.currentLanguage
			)
		) {
			this.orientationModelSubscription =
				this.orientationModel.notifier.subscribe((data) => {
					if (data) {
						this.orientationModelinithandler(data);
					}
				});
			this.orientationModel.initialize(this.courseContextModel.currentLanguage);
		}
	}
	private orientationModelinithandler(data) {
		this.orientationModelSubscription.unsubscribe();
		//this.orientation.initialize();
		//this.orientation.start();
	}
	public updateGeoLocation() {
		this.bUpdateGeoLocation = true;
		if (this.configDocModel.availableGeoLocations) {
			const path: string = this.configDocModel.getLocationMenuXML(
				this.courseContextModel.currentLanguage
			);
			this.geoLocationModel.initialize(
				path,
				this.configDocModel.availableGeoLocations
			);
			this.geolocationSubscription = this.geoLocationModel.notifier.subscribe(
				(data) => {
					if (data === "data") {
						this.updateStateSpecificContentmodel();
					}
				}
			);
		} else {
			this.courseContextModel.updateCoursePage();
		}
	}
	private initStateSpecificContentModelIfLessonStatus() {
		if (TrackingManager.instance.trackingVO.initialLessonLocation) {
			this.initStateSpecificContentModel();
		}
	}
	public initStateSpecificContentModel() {
		/* Modified to start the timer only if the Geolocation Popup is closed */
		this.courseTimer.startTimer();
		/*---------------------------------------------------------------------------------------------------*/
		this.setAppHeaderData();
		const path: string = this.configDocModel.getStateSpecificContentXML(
			this.courseContextModel.currentLanguage
		);
		this.stateSpecificContentModel.initilize(
			path,
			this.geoLocationModel.selectedGeoLocation
		);
		if (this.bUpdateGeoLocation) {
			this.bUpdateGeoLocation = false;
			this.courseContextModel.updateCoursePage();
			// if(!(/MSIE \d|Trident.*rv:/i.test(navigator.userAgent)))
			this.checkCourseLoaded();
		} else {
			//this.initCourseStructureModel();
			//this.orientation.initialize();
			//this.orientation.start();
		}
		if (this.showIntroJS) {
			this.loadOrientation();
		}
	}
	public presentationModeUpdate(mode: string) {
		TrackingManager.instance.updateLessonLocation(
			AppConstants.PRESENTATION_MODE,
			mode
		);
		TrackingManager.instance.saveData(true);
		this.configDocModel.setPresentationMode(mode);
		ApplicationModel.instance.presMode = mode;
	}
	public presentationModeUpdateByPopup(mode: string) {
		TrackingManager.instance.updateLessonLocation(
			AppConstants.PRESENTATION_MODE,
			mode
		);
		TrackingManager.instance.saveData(true);
		this.configDocModel.setPresentationMode(mode);
		ApplicationModel.instance.presMode = mode;
		//if(!(/MSIE \d|Trident.*rv:/i.test(navigator.userAgent)))
		this.checkCourseLoaded();
	}

	private setLabelInLanguageOptions() {
		this.configDocModel.setLabelInLanguageOptions(
			this.courseMenuModel.languageAssets
		);
		ApplicationModel.instance.flowDirection =
			this.configDocModel.availableLanguages.find(
				(x) => x.language == this.courseContextModel.currentLanguage
			).direction;
	}
	public setAppHeaderData() {
		console.log("setAppHeaderData");
		this.appHeaderModel.courseTitle = this.configDocModel.getCourseTitle(
			this.courseContextModel.currentLanguage
		);
		this.appHeaderModelAdaptive.courseTitle =
			this.configDocModel.getCourseTitle(
				this.courseContextModel.currentLanguage
			);
		this.appHeaderModel.languages = this.configDocModel.availableLanguages;
		this.appHeaderModelAdaptive.languages =
			this.configDocModel.availableLanguages;
		this.appHeaderModel.language = this.configDocModel.availableLanguages.find(
			(x) => x.language == this.courseContextModel.currentLanguage
		).label;
		this.appHeaderModelAdaptive.language =
			this.configDocModel.availableLanguages.find(
				(x) => x.language == this.courseContextModel.currentLanguage
			).label;
		this.appHeaderModel.customDocs =
			this.configDocModel.getCustomDocsForLanguage(
				this.courseContextModel.currentLanguage
			);
		this.appHeaderModelAdaptive.customDocs =
			this.configDocModel.getCustomDocsForLanguage(
				this.courseContextModel.currentLanguage
			);
		this.appHeaderModel.docBar = this.configDocModel.docBar;
		this.appHeaderModelAdaptive.docBar = this.configDocModel.docBar;
		//document.getElementById("page-header").style.direction = UtilityScripts.textDirection;
		//UtilityScripts.setTextDirection( document.getElementById("page-header"),ApplicationModel.instance.flowDirection);
		console.log(
			this.configDocModel.getCourseTitle(
				this.courseContextModel.currentLanguage
			) +
				" || " +
				this.configDocModel.availableLanguages.find(
					(x) => x.language == this.courseContextModel.currentLanguage
				).label +
				" || " +
				this.configDocModel.getCustomDocsForLanguage(
					this.courseContextModel.currentLanguage
				) +
				" || " +
				this.configDocModel.docBar
		);
	}

	private setSideBarData() {
		this.courseStructureModel.addDescriptorToStructure(
			this.descriptorModel.txtFields
		);
		UtilityScripts.setTextDirection(
			document.getElementById("sidebar-wrapper"),
			ApplicationModel.instance.flowDirection
		);
		//document.getElementById("sidebar-wrapper").style.direction = UtilityScripts.textDirection;
	}

	private setPresentationModeData() {
		this.configDocModel.updatePresentationModeName(
			this.descriptorModel.txtFields
		);
	}

	private setRightContainer() {
		//document.getElementById("body-content").style.direction = UtilityScripts.textDirection;
		//UtilityScripts.setTextDirection(document.getElementById("body-content"),ApplicationModel.instance.flowDirection);
	}

	protected initTimer() {
		console.log("this.courseTimer init ");
		this.courseTimer.initialize();
		/*  if(this.configDocModel.minimumTime != null && this.configDocModel.minimumTime > 0) {
            this.courseTimer.isCourseTimerAvailable = true;
            this.courseTimer.initialize(this.configJsonModel.configData['saveInt'],this.configDocModel.minimumTime);
        }
        else {
            this.courseTimer.initialize(this.configJsonModel.configData['saveInt'], 0);
            this.courseTimer.isCourseTimerAvailable = false;
        }
        this.courseTimer.startTimer();*/
	}
	protected setTimer() {
		if (
			this.configDocModel.minimumTime != null &&
			this.configDocModel.minimumTime > 0
		) {
			this.courseTimer.isCourseTimerAvailable = true;
			this.courseTimer.setTimer(
				this.configJsonModel.configData["saveInt"],
				this.configDocModel.minimumTime
			);
			/* Timer resumes when the course is relaunched from LMS */
			if (TrackingManager.instance.trackingVO.initialLessonLocation) {
				this.courseTimer.startTimer();
			}
			/* ----------------------------------------------------- */
		} else {
			this.courseTimer.isCourseTimerAvailable = false;
		}
	}
	/* Added to support saveInt config parameter */
	private startSaveIntTimer() {
		if (this.configJsonModel.configData["saveInt"] > 0) {
			clearInterval(this.saveIntTimer);
			this.saveIntTimer = setInterval(function () {
				TrackingManager.instance.saveData(true);
			}, this.configJsonModel.configData["saveInt"] * 60000);

			this.exitCourseSubscription = this.appUtilityService.notifier.subscribe(
				(data) => {
					if (data === "exitCourse") {
						this.exitCourseSubscription.unsubscribe();
						this.endSaveIntTimer();
					}
				}
			);
		}
		this.maxIdleTimeReachedSubscription =
			this.appService.maxIdleTimeReached$.subscribe((data) => {
				this.endSaveIntTimer();
			});
	}
	private endSaveIntTimer() {
		clearInterval(this.saveIntTimer);
	}
	/* ---------------------------------------------------------------*/
	public async languageUpdate(lang: string) {
		this.courseContextModel.currentLanguage = lang;
		this.courseStructureModel.updateLanguage(lang);
		this.configDocModel.updatePresentationModeName(
			this.descriptorModel.txtFields
		);
		let courseStructure =
			await this.courseStructureModel.parseBaseStructureAndApplySceneChange();
		setTimeout(() => {
			TrackingManager.instance.initBookmarks(
				this.courseTimer.sessionTimeString,
				this.courseTimer.totalTimeString,
				this.courseStructureModel.courseStructureVO
			);
			console.log(
				"languageUpdate this.courseStructureModel.courseStructureVO   ",
				this.courseStructureModel.courseStructureVO
			);
			this.courseContextModel.updateCompletedPagesInCourse();
			this.initDescriptor();
			this.updateGeoLocation();
			this.initDefinition();
			this.initOrientationModel();
		}, 100);
	}
	public async languageUpdateFromDropdown(lang: string) {
		if (this.courseContextModel.currentLanguage === lang) return false;

		this.courseContextModel.currentLanguage = lang;
		this.courseStructureModel.updateLanguage(lang);
		this.configDocModel.updatePresentationModeName(
			this.descriptorModel.txtFields
		);
		let courseStructure =
			await this.courseStructureModel.parseBaseStructureAndApplySceneChange();
		setTimeout(() => {
			TrackingManager.instance.initBookmarks(
				this.courseTimer.sessionTimeString,
				this.courseTimer.totalTimeString,
				this.courseStructureModel.courseStructureVO
			);
			console.log(
				"languageUpdate this.courseStructureModel.courseStructureVO   ",
				this.courseStructureModel.courseStructureVO
			);
			//this.courseContextModel.updateCompletedPagesInCourse();
			this.courseContextModel.updatePageById(
				this.courseContextModel.currentPageInfo.page_id
			);
			this.initDescriptor();
			//this.updateStateSpecificContentmodel();
			this.updateGeoLocation();
			this.initDefinition();
		}, 100);
	}
	public updateStateSpecificContentmodel() {
		if (
			this.configDocModel.hasStateSpecificXML(
				this.courseContextModel.currentLanguage
			)
		) {
			const path: string = this.configDocModel.getStateSpecificContentXML(
				this.courseContextModel.currentLanguage
			);
			this.stateSpecificContentModel.initilize(
				path,
				this.geoLocationModel.selectedGeoLocation
			);
		}
	}
	public audioUpdate(audioOn: boolean): void {
		this.courseContextModel.audioOn = audioOn;
	}
	public get showGeolocation() {
		return (
			(this.geoLocationModel.showGeoLocation && this.bShowPopup) ||
			(this.geoLocationModel.showGeoLocation && !this.bGeoLocationPresent)
		);
	}
	public resetStateSpecificIcon() {
		this.stateSpecificContentModel.bShowStateSpecificIcon = false;
	}
	public get configParams() {
		return this.objParams;
	}

	public set configParams(val: any) {
		this.objParams = val;
	}
	protected checkCourseLoaded() {
		let subscription: any;
		let owner = this;
		subscription = this.appService.rubricLoaded$.subscribe((data) => {
			subscription.unsubscribe();
			this.appService.rubricStateUpdate({ state: "pause" });
			owner.isCourseLoaded = true;
			owner.loaderService.hide();
			setTimeout(function () {
				//if (/MSIE \d|Trident.*rv:/i.test(navigator.userAgent)) {
					if (
						owner.showOrientation &&
						!owner.orientation.OrientationCompleted && !this.showGeolocation
					) {
						owner.loadOrientation();
					}
					/* else{
					    owner.showIntroJS=true;
					} */
				/* } else if (
					owner.showOrientation &&
					!owner.orientation.OrientationCompleted
				) {
					owner.orientation.initialize();
					owner.orientation.start();
				} */
			}, 100);
		});
	}
	public preferenceViewClosed() { //when language and presentationMode Selected
		/* Modified to start the timer only if the Presentation Popup is closed and there is no Geolocation */
		if (!this.showGeolocation) {
			this.courseTimer.startTimer();
		}
		/*---------------------------------------------------------------------------------------------------*/
		this.showOrientation = this.configDocModel.hasOrientation(
			this.courseContextModel.currentLanguage
		)
			? true
			: false;
		if (this.bShowPopup) {
			//if (/MSIE \d|Trident.*rv:/i.test(navigator.userAgent)) {
				if (this.showOrientation && !this.orientation.OrientationCompleted && !this.showGeolocation) {
					this.loadOrientation();
				} else {
					this.showIntroJS = true;
				}
			/* } else if (
				this.showOrientation &&
				!this.orientation.OrientationCompleted
			) {
				this.orientation.initialize();
				this.orientation.start();
			} */
		}
		if (!this.showOrientation) {
			const _iOSDevice = navigator.platform.indexOf("MacIntel") != -1;
			if (
				window.innerWidth > 768 &&
				!(UtilityScripts.isMobileDevice() || _iOSDevice)
			) {
				this.appService.toggleLeftMenu("page-inner-wrap");
			}
		}
	}

	public loadOrientation() {
		if (this._ieOrientationDisplyed) {
			this.introJS.setOptions({
				nextLabel: this.descriptorModel.getDescriptorTextById("next_str"),
				prevLabel: this.descriptorModel.getDescriptorTextById("back_str"),
				skipLabel: "x",
				hidePrev: true,
				hideNext: true,
				tooltipClass: ApplicationModel.instance.textDirection,
				exitOnOverlayClick: false,
				exitOnEsc: false,
				doneLabel: this.descriptorModel.getDescriptorTextById("ok_str"),
			});

			this.introJS.start();
			this.setFocusOnToolTipText();

			this.introJS.onafterchange(() => {
				setTimeout(() => {
					this.setFocusOnToolTipText();
				}, 500);
			});

			if (!this._skippableOrientation) {
				this.enabledNext = false;
				this.enabledNext = true;
				let skipEl = document.getElementsByClassName("introjs-skipbutton");
				let okEl = document.getElementsByClassName("introjs-okbutton");

				if (skipEl.length) {
					skipEl[0].classList.add("remove-skip");
				}
				if (okEl.length) {
					okEl[0].classList.add("remove-skip");
				}

				this.introJS.onafterchange((targetElement) => {
					setTimeout(() => {
						this.setFocusOnToolTipText();
					}, 500);
					let skipEl = document.getElementsByClassName("introjs-skipbutton");
					let okEl = document.getElementsByClassName("introjs-okbutton");
					if (skipEl.length) {
						skipEl[0].classList.add("remove-skip");
					}
					if (okEl.length) {
						okEl[0].classList.add("remove-skip");
					}
					if (this.introJS._direction && this.introJS._direction == "forward") {
						if (this.introJS._currentStep >= this._maxStepIndexReached) {
							this._maxStepIndexReached = this.introJS._currentStep;
							this.enabledNext = false;
							this._maxStepIndexReached = this.introJS._currentStep + 1;
							this.enabledNext = true;
						} else {
							clearTimeout(this._enabledNextTimeoutID);
						}
					} else {
						this.enabledNext = true;
						clearTimeout(this._enabledNextTimeoutID);
					}
				});
				
			}

			let pageBody = document.getElementsByClassName("page-right-container");
			let notBurstCourse = document.getElementsByClassName("sidebar-submenu");
			if (UtilityScripts.isMobileDevice()) {
				this.introJS.onchange(() => {
					if(document.getElementsByClassName("coursetimer").length == 1){
						if (this.introJS._currentStep === 3) {
							this.toggleMenuAndAddClass(pageBody);
						} else {
							this.toggleMenuAndRemoveClass(pageBody);
						}
					} else {
						if(notBurstCourse.length > 0){
							if (this.introJS._currentStep === 2) {
								this.toggleMenuAndAddClass(pageBody);
							} else {
								this.toggleMenuAndRemoveClass(pageBody);
							}
						}
					} 
				});
				this.introJS.onexit(() => {
					this.toggleMenuAndRemoveClass(pageBody);
				});
			}

			this._ieOrientationDisplyed = false;
		}
	}

	set enabledNext(value: boolean) {
		let nextNdoneEl = document.querySelectorAll(
			".introjs-nextbutton,.introjs-donebutton"
		);
		let btnList = Array.prototype.slice.call(nextNdoneEl); // converted to array to work in IE
		btnList = btnList && btnList.length ? btnList : [];
		if (value) {
			btnList.forEach((element) => {
				element.classList.remove("disable-done-next");
			});
			this._enabledNext = true;
		} else {
			btnList.forEach((element) => {
				element.classList.add("disable-done-next");
			});
			this._enabledNext = false;
		}
	}

	private setFocusOnToolTipText() {
		let tooltiptext = document.getElementsByClassName("introjs-tooltiptext");
		tooltiptext[0].setAttribute('role', 'dialog');
		tooltiptext[0].setAttribute('tabindex', '0');
		(tooltiptext[0] as HTMLElement).focus();
	}

	private toggleMenuAndAddClass(pageBody) {
		this.appService.toggleLeftMenu("page-inner-wrap introfix");
		if (pageBody.length) {
			pageBody[0].classList.add("zIndexToggle");
		}
	}

	private toggleMenuAndRemoveClass(pageBody) {
		this.appService.toggleLeftMenu("page-inner-wrap toggled");
		pageBody[0].classList.remove("zIndexToggle");
	}

	private configTheming() {
		let theme_colors: any[] = this.configDocModel.theming_colors;
		this.themingService.initialize(theme_colors);
		this.themingService.setTheme();
	}
}
